import styled from "styled-components";

export const PdfContent = styled.div`

    .center-circular-progress{
        width: 100%;
    text-align: center;
    }

.format-file{
    border: 1px solid #e9e9e9;
    padding: 0 10px;
    border-radius: 4px;
    margin-bottom: 10px;
}
    .format-btn{
        margin: 10px 5px 3px 5px;
    }
    
.float-buttons {
    display: flex;
    margin-left: 10px;

.float-button:hover .tooltip {
    opacity: 1;
    }
}

.button {
    background-color: #fff;
    color: #6f6e6e;
    padding: 10px 15px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    transition: background-color 0.3s ease;
    margin-bottom: 10px;
    margin-right: 6px
}

.button:hover {
    background-color: #22385121;
}

.files {
    display: ruby;
    justify-content: space-between;
    width: 500px;
}

.files:hover {
  background-color: #2238510f;
}
`;

